<router-outlet />
<!-- <div class="text-center">Versión {{version}}</div> -->
<p-dialog header="Problemas de conexión" [(visible)]="display" position="top" [modal]="true" [closable]="false">
    {{message}}
    <div class="text-center mt-2">
        <button pButton label="Cerrar" icon="pi pi-times-circle" class="p-button p-button-success"
            (click)="reload()"></button>
    </div>
</p-dialog>

<p-dialog header="¿Deseas soporte?" [(visible)]="displayHelp" position="top" [modal]="true" [closable]="false">
    <div class="text-center">
        <h4>¿Tienes problemas con la aplicación o requieres una ayuda?</h4>
        <p>Escribenos al whatsapp +57 315 474 7195</p>
    </div>
    <div class="text-center mt-2">
        <button pButton label="Cerrar" icon="pi pi-times-circle" class="p-button p-button-success"
            (click)="displayHelp=false"></button>
    </div>
</p-dialog>

<!-- <button class="p-button p-button-warning fixed bottom-0" [style]="'right:-23px'" [rounded]="true" (click)="openHelp()"
    style="z-index:9988" pButton icon="pi pi-headphones text-2xl" label="&nbsp;&nbsp;"></button> -->